import { createStore } from 'redux';

import translationsReducer from './redux/reducers';

export default createStore(translationsReducer);
